import React from 'react';
import { useTranslation } from 'react-i18next';
import PilotCodeOfConductText from './PilotCodeOfConductText';
import './PilotCodeOfConductModal.css';

export default function PilotCodeOfConductModal({ onConfirm }) {
  const { t } = useTranslation();

  return (
    <div
      className="pilot-code-modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="pilot-code-modal-title"
    >
      <div className="pilot-code-modal card">
        <h2 id="pilot-code-modal-title" className="pilot-code-modal-heading">
          {t('pilot.conductLoginTitle')}
        </h2>
        <div className="pilot-code-modal-scroll">
          <PilotCodeOfConductText />
        </div>
        <div className="pilot-code-modal-actions">
          <button type="button" className="btn btn-primary" onClick={onConfirm}>
            {t('pilot.conductOk')}
          </button>
        </div>
      </div>
    </div>
  );
}
